var map = {
	"./Orange_circle_N.png": "./src/assets/allThePoints/legend/Orange_circle_N.png",
	"./Red_star_K7.png": "./src/assets/allThePoints/legend/Red_star_K7.png",
	"./black_circle.png": "./src/assets/allThePoints/legend/black_circle.png",
	"./black_question.png": "./src/assets/allThePoints/legend/black_question.png",
	"./black_square_U3.png": "./src/assets/allThePoints/legend/black_square_U3.png",
	"./black_triangle.png": "./src/assets/allThePoints/legend/black_triangle.png",
	"./blue_circle.png": "./src/assets/allThePoints/legend/blue_circle.png",
	"./blue_green_circle.png": "./src/assets/allThePoints/legend/blue_green_circle.png",
	"./blue_square.png": "./src/assets/allThePoints/legend/blue_square.png",
	"./dark_blue_circle.png": "./src/assets/allThePoints/legend/dark_blue_circle.png",
	"./green_circle.png": "./src/assets/allThePoints/legend/green_circle.png",
	"./green_diamond_A4.png": "./src/assets/allThePoints/legend/green_diamond_A4.png",
	"./green_donut.png": "./src/assets/allThePoints/legend/green_donut.png",
	"./green_hexagon.png": "./src/assets/allThePoints/legend/green_hexagon.png",
	"./green_question.png": "./src/assets/allThePoints/legend/green_question.png",
	"./green_square.png": "./src/assets/allThePoints/legend/green_square.png",
	"./green_star_A3.png": "./src/assets/allThePoints/legend/green_star_A3.png",
	"./green_triangle.png": "./src/assets/allThePoints/legend/green_triangle.png",
	"./grey_circle.png": "./src/assets/allThePoints/legend/grey_circle.png",
	"./grey_diamond.png": "./src/assets/allThePoints/legend/grey_diamond.png",
	"./grey_question.png": "./src/assets/allThePoints/legend/grey_question.png",
	"./grey_square.png": "./src/assets/allThePoints/legend/grey_square.png",
	"./grey_star_of_david.png": "./src/assets/allThePoints/legend/grey_star_of_david.png",
	"./grey_triangle.png": "./src/assets/allThePoints/legend/grey_triangle.png",
	"./maroon_circle.png": "./src/assets/allThePoints/legend/maroon_circle.png",
	"./pink_circle.png": "./src/assets/allThePoints/legend/pink_circle.png",
	"./pink_square.png": "./src/assets/allThePoints/legend/pink_square.png",
	"./pink_star.png": "./src/assets/allThePoints/legend/pink_star.png",
	"./purple_circle_C.png": "./src/assets/allThePoints/legend/purple_circle_C.png",
	"./red_black_circle.png": "./src/assets/allThePoints/legend/red_black_circle.png",
	"./red_circle.png": "./src/assets/allThePoints/legend/red_circle.png",
	"./red_diamond.png": "./src/assets/allThePoints/legend/red_diamond.png",
	"./red_question_mark.png": "./src/assets/allThePoints/legend/red_question_mark.png",
	"./red_square.png": "./src/assets/allThePoints/legend/red_square.png",
	"./red_star_of_david.png": "./src/assets/allThePoints/legend/red_star_of_david.png",
	"./red_triangle_K4.png": "./src/assets/allThePoints/legend/red_triangle_K4.png",
	"./yellow_circle_O.png": "./src/assets/allThePoints/legend/yellow_circle_O.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/allThePoints/legend sync \\.png$";